const CONSUMED_LOGIN_QUERY_KEYS = [
  'returnData',
  'userName',
  'token',
  'lzCode',
  'channelLogin',
  'h5Repay'
]

/**
 * 登录上下文写入缓存后清理敏感查询参数，同时保留其他历史业务参数。
 */
export const buildUrlAfterReturnDataConsumed = ({ pathname = '', search = '', hash = '' }) => {
  const query = String(search).replace(/^\?/, '')
  const retainedQuery = query.split('&').filter(Boolean).filter(part => {
    const rawKey = part.split('=')[0]
    try {
      return !CONSUMED_LOGIN_QUERY_KEYS.includes(decodeURIComponent(rawKey))
    } catch (e) {
      // 非法编码的未知参数原样保留，避免清理登录态时破坏其他历史业务参数。
      return true
    }
  }).join('&')
  return `${pathname}${retainedQuery ? `?${retainedQuery}` : ''}${hash}`
}
